// import router from '@/router'

/**
 * 合并路由的 meta（子路由覆盖父路由）
 * @param {Object} route - Vue Router 的 route 对象
 * @returns {Object} 合并后的 meta 对象
 */
export function getMergedMeta(route) {
  const matched = route.matched
  const mergedMeta = {}

  // 从父到子遍历,后面的会覆盖前面的
  for (let i = 0; i < matched.length; i++) {
    if (matched[i].meta) {
      Object.assign(mergedMeta, matched[i].meta)
    }
  }

  return mergedMeta
}

/**
 * 获取 hash 路径
 * @param {string} url - 完整的 URL 字符串
 * @returns {string} 获取 hash 路径
 */
export function getHashPath(url) {
  const u = new URL(url, location.origin)
  const hash = u.hash.startsWith('#') ? u.hash.slice(1) : u.hash
  return hash.split('?')[0] || '/'
}
